import { z } from 'zod';
import { idArray } from './shared.schema';

export const bankReconciliationVariants = ['full', 'revenueOnly'] as const;
export const bankReconciliationOutputFormats = ['csv', 'xlsx'] as const;

export const bankReconciliationVariantSchema = z.enum(bankReconciliationVariants);
export const bankReconciliationOutputFormatSchema = z.enum(bankReconciliationOutputFormats);

export const bankReconciliationParametersSchema = z
	.strictObject({
		variant: bankReconciliationVariantSchema,
		outputFormat: bankReconciliationOutputFormatSchema.default('csv'),
		startServiceDate: z.iso.date(),
		endServiceDate: z.iso.date(),
		bankAccountId: z.number().int().nullable().optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.endServiceDate < value.startServiceDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endServiceDate'],
				message: 'End service date must be on or after start service date',
			});
		}
	});

export type BankReconciliationVariant = z.infer<typeof bankReconciliationVariantSchema>;
export type BankReconciliationOutputFormat = z.infer<typeof bankReconciliationOutputFormatSchema>;
export type BankReconciliationParameters = z.infer<typeof bankReconciliationParametersSchema>;
